export class StringUtils {

  public static leftPad(str: any, len: number, ch: any): string {
    const parsedStr = `${str}`;
    len = len - parsedStr.length + 1;
    return len > 0 ?
      new Array(len).join(ch) + parsedStr : parsedStr;
  }

  public static isNotNull(value: Object) {
    return value !== null && value !== undefined;
  }

  public static stripHTML(value: any): any {
    if (!StringUtils.isNotNull(value)) {
      return value;
    }
    return JSON.parse(JSON.stringify(value).replace(/<[^>]*>/g, ''));
  }
}
